import React, { useEffect, useState } from "react";
import InputMask from "react-input-mask";
import { Save, Search } from "lucide-react";
import { listarTabelasPreco } from "../services/api";

const vazio = {
  ativo: true,
  cnpj: "",
  inscricaoEstadual: "",
  razaoSocial: "",
  nomeFantasia: "",
  logradouro: "",
  numero: "",
  complemento: "",
  bairro: "",
  cep: "",
  cidade: "",
  estado: "",
  email: "",
  telefone: "",
  simplesNacional: true,
  tabelaPrecoId: "",
  produtoZenPdv: true,
  produtoZenTag: true,
  produtoZenGestao: true,
  produtoZenMobile: true,
  produtoZenPass: true,
};

const inputClass = `
  w-full px-3 py-2.5 rounded-xl border outline-none transition
  zen-card border-gray-300 text-gray-900 placeholder:text-gray-400
  focus:ring-2 focus:ring-blue-500/60
  dark:bg-slate-950/40 dark:border-white/10 dark:text-white dark:placeholder:text-slate-400
  dark:focus:ring-blue-400/40
`;

const labelClass = "block text-sm font-medium text-gray-700 dark:text-slate-200 mb-1";
const soDigitos = (v) => String(v || "").replace(/\D/g, "");

const FormularioDistribuidor = ({ token, initialData = null, isEdit = false, onSubmit }) => {
  const [form, setForm] = useState(vazio);
  const [tabelas, setTabelas] = useState([]);
  const [saving, setSaving] = useState(false);
  const [loadingCnpj, setLoadingCnpj] = useState(false);

  useEffect(() => {
    listarTabelasPreco(token, { ativo: true })
      .then((r) => {
        const all = Array.isArray(r.data) ? r.data : [];
        setTabelas(all.filter((t) => !t.distribuidorId));
      })
      .catch(() => setTabelas([]));
  }, [token]);

  useEffect(() => {
    if (!initialData) return;
    const d = initialData.distribuidor || initialData;
    setForm({
      ...vazio,
      ativo: d.ativo !== false,
      cnpj: d.cnpj || "",
      inscricaoEstadual: d.inscricaoEstadual || "",
      razaoSocial: d.razaoSocial || "",
      nomeFantasia: d.nomeFantasia || "",
      logradouro: d.logradouro || "",
      numero: d.numero || "",
      complemento: d.complemento || "",
      bairro: d.bairro || "",
      cep: d.cep || "",
      cidade: d.cidade || "",
      estado: d.estado || "",
      email: d.email || "",
      telefone: d.telefone || "",
      simplesNacional: !!d.simplesNacional,
      tabelaPrecoId: d.tabelaPrecoId ? String(d.tabelaPrecoId) : "",
      produtoZenPdv: d.produtoZenPdv !== false,
      produtoZenTag: d.produtoZenTag !== false,
      produtoZenGestao: d.produtoZenGestao !== false,
      produtoZenMobile: d.produtoZenMobile !== false,
      produtoZenPass: d.produtoZenPass !== false,
    });
  }, [initialData]);

  const set = (name) => (e) => {
    const { value, type, checked } = e.target;
    setForm((f) => ({ ...f, [name]: type === "checkbox" ? checked : value }));
  };

  const buscarCnpj = async () => {
    const cnpj = soDigitos(form.cnpj);
    if (cnpj.length !== 14) {
      alert("Informe um CNPJ válido.");
      return;
    }
    setLoadingCnpj(true);
    try {
      const res = await fetch(`https://publica.cnpj.ws/cnpj/${cnpj}`);
      const data = await res.json();
      const est = data?.estabelecimento;
      setForm((prev) => ({
        ...prev,
        razaoSocial: data?.razao_social || prev.razaoSocial,
        nomeFantasia: est?.nome_fantasia || prev.nomeFantasia,
        logradouro: est?.logradouro || prev.logradouro,
        numero: est?.numero || prev.numero,
        complemento: est?.complemento || prev.complemento,
        bairro: est?.bairro || prev.bairro,
        cep: est?.cep || prev.cep,
        cidade: est?.cidade?.nome || prev.cidade,
        estado: est?.estado?.sigla || prev.estado,
        email: est?.email || prev.email,
        telefone: est?.telefone1 || prev.telefone,
        inscricaoEstadual: est?.inscricoes_estaduais?.[0]?.inscricao_estadual || prev.inscricaoEstadual,
        simplesNacional: data?.simples?.simples === "Sim",
      }));
    } catch (err) {
      console.error(err);
      alert("Erro ao buscar CNPJ. Tente novamente.");
    } finally {
      setLoadingCnpj(false);
    }
  };

  const salvar = async (e) => {
    e.preventDefault();
    const cnpj = soDigitos(form.cnpj);
    if (cnpj.length !== 14) {
      alert("Informe um CNPJ válido com 14 dígitos.");
      return;
    }
    const payload = {
      distribuidor: {
        ativo: Boolean(form.ativo),
        razaoSocial: form.razaoSocial.trim(),
        nomeFantasia: form.nomeFantasia.trim(),
        cnpj,
        logradouro: form.logradouro.trim(),
        numero: form.numero.trim(),
        complemento: form.complemento.trim(),
        bairro: form.bairro.trim(),
        cidade: form.cidade.trim(),
        estado: form.estado.trim().toUpperCase(),
        cep: soDigitos(form.cep),
        email: form.email.trim(),
        telefone: soDigitos(form.telefone),
        inscricaoEstadual: form.inscricaoEstadual.trim(),
        simplesNacional: !!form.simplesNacional,
        tabelaPrecoId: form.tabelaPrecoId ? Number(form.tabelaPrecoId) : null,
        produtoZenPdv: !!form.produtoZenPdv,
        produtoZenTag: !!form.produtoZenTag,
        produtoZenGestao: !!form.produtoZenGestao,
        produtoZenMobile: !!form.produtoZenMobile,
        produtoZenPass: !!form.produtoZenPass,
      },
    };
    setSaving(true);
    try {
      await onSubmit(payload, token);
    } catch (err) {
      const data = err?.response?.data;
      alert(typeof data === "string" ? data : data?.message || "Erro ao salvar.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="max-w-5xl mx-auto">
      <div className="zen-card rounded-2xl p-6 md:p-8 shadow-sm dark:backdrop-blur">
        <div className="mb-8">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 dark:text-white">
            {isEdit ? "Editar Distribuidor" : "Cadastro de Distribuidor"}
          </h2>
          <p className="text-sm text-gray-500 dark:text-slate-300/80 mt-1">
            A tabela de preço é a que a Zen usa para cobrar este distribuidor.
          </p>
        </div>

        <form onSubmit={salvar} className="space-y-6">
          <div className="zen-card rounded-2xl p-4 dark:bg-white/5 dark:border-white/10">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div>
                <label className={labelClass}>CNPJ</label>
                <div className="flex">
                  <InputMask
                    mask="99.999.999/9999-99"
                    value={form.cnpj}
                    onChange={set("cnpj")}
                    className={`${inputClass} rounded-r-none`}
                    required
                  />
                  <button
                    type="button"
                    onClick={buscarCnpj}
                    disabled={loadingCnpj}
                    className="px-4 py-2.5 rounded-r-xl font-semibold bg-blue-600 text-white hover:bg-blue-500 disabled:opacity-60 inline-flex items-center"
                    title="Buscar dados pelo CNPJ"
                  >
                    <Search size={18} />
                  </button>
                </div>
                {loadingCnpj && (
                  <p className="text-xs mt-1 text-gray-500 dark:text-slate-300/70">Buscando dados do CNPJ...</p>
                )}
              </div>
              <div className="md:col-span-2">
                <label className={labelClass}>Inscrição Estadual</label>
                <input className={inputClass} value={form.inscricaoEstadual} onChange={set("inscricaoEstadual")} />
              </div>
              <div className="md:col-span-3">
                <label className={labelClass}>Razão Social</label>
                <input className={inputClass} value={form.razaoSocial} onChange={set("razaoSocial")} required />
              </div>
              <div className="md:col-span-3">
                <label className={labelClass}>Nome Fantasia</label>
                <input className={inputClass} value={form.nomeFantasia} onChange={set("nomeFantasia")} required />
              </div>
            </div>
          </div>

          <div className="zen-card rounded-2xl p-4 dark:bg-white/5 dark:border-white/10">
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
              <div className="md:col-span-3">
                <label className={labelClass}>Logradouro</label>
                <input className={inputClass} value={form.logradouro} onChange={set("logradouro")} required />
              </div>
              <div>
                <label className={labelClass}>Número</label>
                <input className={inputClass} value={form.numero} onChange={set("numero")} required />
              </div>
              <div className="md:col-span-2">
                <label className={labelClass}>Complemento</label>
                <input className={inputClass} value={form.complemento} onChange={set("complemento")} />
              </div>
              <div className="md:col-span-2">
                <label className={labelClass}>Bairro</label>
                <input className={inputClass} value={form.bairro} onChange={set("bairro")} required />
              </div>
              <div>
                <label className={labelClass}>CEP</label>
                <InputMask mask="99999-999" className={inputClass} value={form.cep} onChange={set("cep")} required />
              </div>
              <div className="md:col-span-2">
                <label className={labelClass}>Cidade</label>
                <input className={inputClass} value={form.cidade} onChange={set("cidade")} required />
              </div>
              <div>
                <label className={labelClass}>Estado</label>
                <input className={inputClass} value={form.estado} onChange={set("estado")} maxLength={2} required />
              </div>
            </div>
          </div>

          <div className="zen-card rounded-2xl p-4 dark:bg-white/5 dark:border-white/10">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className={labelClass}>Email</label>
                <input type="email" className={inputClass} value={form.email} onChange={set("email")} />
              </div>
              <div>
                <label className={labelClass}>Telefone</label>
                <InputMask mask="(99) 99999-9999" className={inputClass} value={form.telefone} onChange={set("telefone")} />
              </div>
              <div className="md:col-span-2">
                <label className={labelClass}>Tabela de preço</label>
                <select className={inputClass} value={form.tabelaPrecoId} onChange={set("tabelaPrecoId")}>
                  <option value="">— Nenhuma —</option>
                  {tabelas.map((t) => (
                    <option key={t.id} value={t.id}>{t.nome}</option>
                  ))}
                </select>
                <p className="text-xs text-gray-500 mt-1">Tabela da Zen usada para cobrar este distribuidor.</p>
              </div>
              <div className="md:col-span-2">
                <p className="text-sm font-semibold text-gray-800 dark:text-slate-100 mb-2">Produtos ativos</p>
                <p className="text-xs text-gray-500 mb-3">O distribuidor só comercializa e repassa às revendas os produtos marcados.</p>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  {[
                    ["produtoZenPdv", "ZenPDV Desktop"],
                    ["produtoZenTag", "ZenTag"],
                    ["produtoZenGestao", "ZenGestão"],
                    ["produtoZenMobile", "ZenMobile"],
                    ["produtoZenPass", "ZenPass"],
                  ].map(([name, label]) => (
                    <label key={name} className="inline-flex items-center gap-2 rounded-xl border border-gray-200 dark:border-white/10 px-3 py-2">
                      <input type="checkbox" checked={!!form[name]} onChange={set(name)} className="h-4 w-4 rounded" />
                      <span className="text-sm">{label}</span>
                    </label>
                  ))}
                </div>
              </div>
              <div className="md:col-span-2 flex flex-wrap items-center gap-6">
                <label className="inline-flex items-center gap-2 cursor-pointer">
                  <input type="checkbox" checked={!!form.simplesNacional} onChange={set("simplesNacional")} className="h-4 w-4 rounded" />
                  <span className="text-sm font-medium text-gray-700 dark:text-slate-200">Simples Nacional</span>
                </label>
                <label className="inline-flex items-center gap-2 cursor-pointer">
                  <input type="checkbox" checked={!!form.ativo} onChange={set("ativo")} className="h-4 w-4 rounded" />
                  <span className="text-sm font-medium text-gray-700 dark:text-slate-200">Ativo</span>
                </label>
              </div>
            </div>
          </div>

          <div className="flex justify-end pt-2">
            <button
              disabled={saving}
              className="inline-flex items-center gap-2 px-6 py-3 rounded-xl font-semibold text-sm bg-blue-600 text-white hover:bg-blue-500 disabled:opacity-60"
            >
              <Save size={18} />
              {saving ? "Salvando..." : isEdit ? "Salvar Alterações" : "Cadastrar Distribuidor"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default FormularioDistribuidor;
